import React from 'react';
import cn from 'classnames';
import type { Data, HeaderSteps, LocalsType } from 'types';

import { useInnerWidth } from 'hooks';
import Logo from 'layouts/header/Logo';

import headerCss from '../index.module.css';
import css from './headerWithSteps.module.css';

/* ------------------------------------------------------------------------------------ */

const MOBILE = 768;

interface HeaderWithStepsProps {
  steps: HeaderSteps['steps'];
  currentStep: string;
  locals?: LocalsType;
}

/* ------------------------------------------------------------------------------------ */

const HeaderWithSteps = (props: HeaderWithStepsProps & Data) => {
  const { steps, currentStep } = props;

  const innerWidth = useInnerWidth(true);

  const isCurrentStep = (step) => step.value === currentStep;

  return (
    <nav className={cn('navbar p-0', headerCss.navbar)}>
      <div className={cn('container d-flex flex-nowrap gg-16', headerCss.container)}>
        <Logo showSmallLogo={innerWidth < 992} />

        {steps && (
          <ol className={cn('d-flex align-items-center gg-6 my-0 mx-auto p-0 w-100 overflow-hidden w-max', css.list)}>
            {steps.map((step, idx) => (
              <React.Fragment key={`${step.label}-${idx}`}>
                <li
                  className={cn('d-flex align-items-center gg-6', css.step, {
                    'white-text': isCurrentStep(step),
                  })}
                >
                  <span
                    className={cn('d-flex justify-content-center rounded-circle', css.stepNumber, {
                      [css.currentStepNumber]: isCurrentStep(step),
                    })}
                  >
                    {idx + 1}
                  </span>

                  {innerWidth > MOBILE && <span>{step.label}</span>}
                </li>

                {idx < steps.length - 1 && <span className={cn(css.separator, 'flex-fill')} />}
              </React.Fragment>
            ))}
          </ol>
        )}
      </div>
    </nav>
  );
};

export default HeaderWithSteps;
